import React from "react";
import "./footer.css";
import templeJson from "../../../config/temple.json";
import { TextField, Button } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LanguageIcon from "@mui/icons-material/Language";
import InstagramIcon from "@mui/icons-material/Instagram";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Link } from "react-router-dom";
import { useFooterFunctions } from "./CustomHook";

function Footer() {
  const {
    navigate,
    checkLoggedIn,
    commingSoon,
    onSubmit,
    register,
    handleSubmit,
    errors,
    reset,
  } = useFooterFunctions();

  const renderMenuItems = (items) => {
    return items.map((item, index) => (
      <Link key={index} to={item?.url} className={templeJson["Footer"]?.style == 1
        ? "nav-text-dark"
        : "nav-text-light"}>
        <KeyboardArrowRightIcon /> {item?.name}
      </Link>
    ));
  };
  return (
    <>
      <div
        className={
          templeJson["Footer"]?.style == 1
            ? "container-fluid footer py-4"
            : "container-fluid footer-svt py-4"
        }
        style={
          templeJson["Footer"]?.style == 1
            ? {
                background: `linear-gradient(
              rgba(187, 157, 165, 0.9),
              rgba(187, 157, 165, 0.9)
            ),
            url(${process.env.REACT_APP_S3_BASE_URL}/api/images/footer-bg.jpg)`,
              }
            : {}
        }
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <h4 className={templeJson["Footer"]?.style == 1
                      ? "text-primary mb-4"
                      : "text-white mb-4"}>Newsletter</h4>
                <p
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "text-para-dark"
                      : "text-para-light"
                  }
                >
                  Please register your email address to be connected with temple
                  and receive regular newsletters and events.
                </p>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    className="input-field mb-2b"
                    id="first_name"
                    label="First Name"
                    variant="outlined"
                    {...register("first_name", {
                      required: "First Name is required",
                    })}
                    error={!!errors.first_name}
                    helperText={errors.first_name?.message}
                  />
                  <TextField
                    className="input-field mb-2b"
                    id="last_name"
                    label="Last Name"
                    variant="outlined"
                    {...register("last_name", {
                      required: "Last Name is required",
                    })}
                    error={!!errors.last_name}
                    helperText={errors.last_name?.message}
                  />
                  <TextField
                    className="input-field mb-2b"
                    id="email"
                    label="Email"
                    variant="outlined"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^\S+@\S+$/i,
                        message: "Invalid email",
                      },
                    })}
                    error={!!errors.email}
                    helperText={errors.email?.message}
                  />
                  <TextField
                    className="input-field mb-2b"
                    id="contact_number"
                    label="Phone"
                    variant="outlined"
                    {...register("contact_number", {
                      required: "Phone number is required",
                    })}
                    error={!!errors.contact_number}
                    helperText={errors.contact_number?.message}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    className="py-3 px-5 text-white"
                    type="submit"
                  >
                    Submit
                  </Button>
                </form>
              </div>{" "}
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div
                className={
                  templeJson["Footer"]?.style == 1
                    ? "footer-item d-flex flex-column"
                    : "footer-item-svt d-flex flex-column"
                }
              >
                <h4 className={templeJson["Footer"]?.style == 1
                      ? "text-primary mb-4"
                      : "text-white mb-4"}>Information</h4>
                {renderMenuItems(templeJson["Footer"]?.Information?.menuItems)}
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div
                className={
                  templeJson["Footer"]?.style == 1
                    ? "footer-item d-flex flex-column"
                    : "footer-item-svt d-flex flex-column"
                }
              >
                <h4 className={templeJson["Footer"]?.style == 1
                      ? "text-primary mb-4"
                      : "text-white mb-4"}>Others</h4>
                {renderMenuItems(templeJson["Footer"]?.Others?.menuItems)}
                <span
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "cursor-pointer-dt"
                      : "cursor-pointer-svt"
                  }
                  onClick={checkLoggedIn}
                >
                  <KeyboardArrowRightIcon /> Volunteer Registration
                </span>
                <span
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "cursor-pointer-dt mt-1"
                      : "cursor-pointer-svt mt-1"
                  }
                  onClick={commingSoon}
                >
                  <KeyboardArrowRightIcon /> Articles of Inc & Bylaws
                </span>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div
                className={
                  templeJson["Footer"]?.style == 1
                    ? "footer-item d-flex flex-column"
                    : "footer-item-svt d-flex flex-column"
                }
              > 
                <h4 className={templeJson["Footer"]?.style == 1
                      ? "text-primary mb-4"
                      : "text-white mb-4"}>Contact Info</h4>
                <Link
                  to="/"
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "icon-left temple-info"
                      : "icon-left text-light"
                  }
                >
                  <LocationOnIcon
                    className={
                      templeJson["Footer"]?.style == 1
                        ? "footer-icon"
                        : "footer-icon-svt"
                    }
                  />{" "}
                  {templeJson["Footer"]?.ContactInfo?.address}
                </Link>
                <Link
                  href={"mailto" + templeJson["Footer"]?.ContactInfo?.email}
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "icon-left temple-info"
                      : "icon-left text-light"
                  }
                >
                  <MailOutlineIcon
                    className={
                      templeJson["Footer"]?.style == 1
                        ? "footer-icon"
                        : "footer-icon-svt"
                    }
                  />
                  {templeJson["Footer"]?.ContactInfo?.email}
                </Link>
                <Link
                  to="/"
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "icon-left temple-info"
                      : "icon-left text-light"
                  }
                >
                  <PhoneIcon
                    className={
                      templeJson["Footer"]?.style == 1
                        ? "footer-icon"
                        : "footer-icon-svt"
                    }
                  />{" "}
                  {templeJson["Footer"]?.ContactInfo?.phone}
                </Link>
                <div>
                  <h4 className={templeJson["Footer"]?.style == 1
                      ? "text-primary mb-4"
                      : "text-white mb-4"}>Website issues</h4>
                  <Link
                    href={"mailto:" + templeJson["Footer"]?.WebsiteIssues?.url}
                    className={
                      templeJson["Footer"]?.style == 1
                        ? "icon-left temple-info"
                        : "icon-left text-light"
                    }
                  >
                    <LanguageIcon
                      className={
                        templeJson["Footer"]?.style == 1
                          ? "footer-icon"
                          : "footer-icon-svt"
                      }
                    />
                    {templeJson["Footer"]?.WebsiteIssues?.url}
                  </Link>
                </div>
                <div>
                  <h4 className={templeJson["Footer"]?.style == 1
                      ? "text-primary mb-4"
                      : "text-white mb-4"}>Follow Us</h4>
                  <ul
                    className={
                      templeJson["Footer"]?.style == 1
                        ? "footer-icon-list"
                        : "footer-icon-list-svt"
                    }
                  >
                    {templeJson["Footer"]?.FollowUs?.icons?.map(
                      (item, index) => {
                        return (
                          <li key={index}>
                            <a
                              href={item?.url}
                              rel="noreferrer"
                              target="_blank"
                            >
                              {item?.name === "Facebook" ? (
                                <FacebookIcon />
                              ) : item?.name === "Youtube" ? (
                                <YouTubeIcon />
                              ) : item?.name === "Instagram" ? (
                                <InstagramIcon />
                              ) : (
                                ""
                              )}
                            </a>
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          templeJson["Footer"]?.style == 1
            ? "container-fluid copyright py-4"
            : "container-fluid copyright-svt py-4"
        }
      >
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-white">
                Copyright © 2024{" "}
                <Link
                  to="/"
                  className={
                    templeJson["Footer"]?.style == 1
                      ? "text-warning"
                      : "text-white"
                  }
                >
                  {templeJson["templeName"]}
                </Link>
                , All right reserved.
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end text-white">
              Designed & Developed by{" "}
              <a
                className={
                  templeJson["Footer"]?.style == 1
                    ? "text-warning border-bottom"
                    : "text-white border-bottom"
                }
                href={templeJson["Footer"]?.CopyRight?.designedby?.url}
              >
                {templeJson["Footer"]?.CopyRight?.designedby?.name}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Footer;
